import { createContext } from 'react';

const UnderlineNavContext = /*#__PURE__*/createContext({
  setChildrenWidth: () => null,
  setNoIconChildrenWidth: () => null,
  loadingCounters: false,
  iconsVisible: true
});

export { UnderlineNavContext };
